import React, { useRef, useState } from 'react'
import GraficaMotosDos from './GraficaMotosDos';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import DateConverter from '../Tools/DateConverter';

function ResumenMotos(props) {
    const { pedidos, valMaximouno, valMaximodos, setLoading, fecha,sucursal } = props;
    const motoFactu = useRef(null);
    const motoDes = useRef(null);
    const [filtro,setFiltro] = useState(8);
    function descargarResumen() {
        var fecc=fecha.split('-')
        setLoading(true);
        let imgDespa = window.document.getElementsByClassName("graficasDespacho")[0];
        let imgFact = window.document.getElementsByClassName("graficasFacturacion")[0];
        html2canvas(imgDespa).then(canvas => {
            var imgDespaC = canvas.toDataURL("image/png");
            var aux0 = pedidos.filter((item) => item.DIFF <= 8);
            var aux1 = pedidos.filter((item) => item.DIFF>8 && item.DIFF <= 15);
            var aux2 = pedidos.filter((item) => item.DIFF > 15 && item.DIFF <= 20);
            var aux3 = pedidos.filter((item) => (item.DIFF) > 20);
            var aux0a = pedidos.filter((item) => item.RETRASO_DS <= 8);
            var aux1a = pedidos.filter((item) => (item.RETRASO_DS) <= 15);
            var aux2a = pedidos.filter((item) => item.RETRASO_DS > 15 && item.DIFF <= 20);
            var aux3a = pedidos.filter((item) => (item.RETRASO_DS) > 20);
            var aux4 = pedidos.filter((item) => item.DIFF >= filtro);
            //aux4.sort((a,b)=>b.DIFF-a.DIFF)
            var aux5 = pedidos.filter((item) => item.RETRASO_DS >= filtro);
            //aux5.sort((a,b)=>b.RETRASO_DS-a.RETRASO_DS)
            html2canvas(imgFact).then(canvasd => {
                var imgFactC = canvasd.toDataURL("image/png");
                console.log(new Date(fecc[0],fecc[1]-1,fecc[2]));
                const pdf = new jsPDF('p', "mm");
                var infoPdf = 1;
                var total = pedidos.length
                pdf.setFont('Helvetica',null);
                pdf.setFontSize(14);
                pdf.text(sucursal.SUCURSAL+'     '+DateConverter.getDiaSemana(new Date(fecc[0],fecc[1]-1,fecc[2]))+'     '+DateConverter.formatoFechaCorto(new Date(fecc[0],fecc[1]-1,fecc[2])), 50, 9);                
                pdf.text(`Total Pedidos: ${total}`, 75, 15)
                pdf.setFontSize(10);
                pdf.text(`<8 min = ${aux0.length} pedidos con un ${parseInt((aux0.length / total) * 100)}%`, 10, 35)
                pdf.text(`Hasta 15 min = ${aux1.length} pedidos con un ${parseInt((aux1.length / total) * 100)}%`, 10, 40)
                pdf.text(`Hasta 20 min = ${aux2.length} pedidos con un ${parseInt((aux2.length / total) * 100)}%`, 10, 45)
                pdf.text(`> 20 min = ${aux3.length} pedidos con un ${parseInt((aux3.length / total) * 100)}%`, 10, 50)
                pdf.setFontSize(13);
                pdf.text("TIEMPO FACTURACIÓN", 10, 70);
                pdf.addImage(imgFactC, "png", 90, 18, 100, 70);
                pdf.text(`>= ${filtro} min`,30,77)
                pdf.setFontSize(10);
                pdf.setFont('Helvetica','bold');
                pdf.text(`#Pe`,10,93);
                pdf.text(`MOTO`,22,93);
                pdf.text(`Tiempo`,37,93);
                pdf.setFont('Helvetica',null);
                pdf.line(10, 95, 197, 95, 'F')
                //pdf.text("OBSERVACIONES", 10, 255)
                //pdf.rect(10, 255, 190, 30, 'S')
                var y = 100
                var x = 10
                var numCol = 1, nuevo = false;
                for (var pedidod of aux4) {
                    if(pedidod.DIFF>=filtro+5){
                        pdf.setTextColor(255, 0, 0);
                    }else{
                        pdf.setTextColor(0, 0, 0);
                        pdf.setFillColor(0,0,0);
                    }
                    pdf.text(`${pedidod.PEDIDO_NRO} `, x, y)
                    pdf.text(`${pedidod.MOTO}`, x + 12, y)
                    pdf.text(`${pedidod.DIFF} min`, x + 27, y)
                    pdf.setTextColor(0, 0, 0);
                    pdf.setFillColor(0,0,0);
                    if (x === 10) { pdf.line(x, y + 2, x + 187, y + 2, 'F') }
                    y += 6
                    if (y >= 285) {
                        if(numCol<4){
                            pdf.line(x+40, nuevo?10:95, x+40, y-3, 'F');
                            pdf.setFont('Helvetica','bold');
                            pdf.text(`#Pe`,x+42,nuevo?10:93)
                            pdf.text(`MOTO`,x+55,nuevo?10:93);
                            pdf.text(`Tiempo`,x+70,nuevo?10:93);
                            pdf.setFont('Helvetica',null);
                        }
                        if (!nuevo) {
                            y = 100
                        } else {
                            y = 15
                        }
                        x += 44
                        numCol += 1
                        if (numCol >= 5) {
                            pdf.addPage()
                            infoPdf += 1;
                            numCol = 1;
                            nuevo = true;
                            y = 15
                            x = 10
                            pdf.setFont('Helvetica','bold');
                            pdf.text(`#Pe`,10,y-5);
                            pdf.text(`MOTO`,22,y-5);
                            pdf.text(`Tiempo`,37,y-5);
                            pdf.line(10, y-4, 197, y-4, 'F');
                            pdf.setFont('Helvetica',null);
                        }
                    }
                }
                pdf.addPage()
                pdf.setFont('Helvetica',null);
                pdf.setFontSize(14);
                pdf.text(sucursal.SUCURSAL+'     '+DateConverter.getDiaSemana(new Date(fecc[0],fecc[1]-1,fecc[2]))+'     '+DateConverter.formatoFechaCorto(new Date(fecc[0],fecc[1]-1,fecc[2])), 50, 9);                
                pdf.text(`Total Pedidos: ${total}`, 75, 15)
                pdf.setFontSize(10);
                pdf.text(`<8 min = ${aux0a.length} pedidos con un ${parseInt((aux0a.length / total) * 100)}%`, 10, 35)
                pdf.text(`Hasta 15 min = ${aux1a.length} pedidos con un ${parseInt((aux1a.length / total) * 100)}%`, 10, 40)
                pdf.text(`Hasta 20 min = ${aux2a.length} pedidos con un ${parseInt((aux2a.length / total) * 100)}%`, 10, 45)
                pdf.text(`> 20 min = ${aux3a.length} pedidos con un ${parseInt((aux3a.length / total) * 100)}%`, 10, 50)
                pdf.setFontSize(13);
                pdf.text("TIEMPO DESPACHO", 10, 70);
                pdf.addImage(imgDespaC, "png", 90, 18, 100, 70);
                //pdf.addImage(imgFactC, "png", 120, 40, 75, 50);
                pdf.text(`>= ${filtro} min`,30,77)
                pdf.setFontSize(10);
                pdf.setFont('Helvetica','bold');
                pdf.text(`#Pe`,10,93);
                pdf.text(`Tiempo`,22,93);
                pdf.setFont('Helvetica',null);
                pdf.line(10, 95, 197, 95, 'F')
                //pdf.text("OBSERVACIONES", 10, 255)
                //pdf.rect(10, 255, 190, 30, 'S')
                y = 100;x = 10;numCol = 1; nuevo = false;
                for (var pedido of aux5) {
                    if(pedido.RETRASO_DS>=filtro+5){
                        pdf.setTextColor(255, 0, 0);
                    }else{
                        pdf.setTextColor(0, 0, 0);
                        pdf.setFillColor(0,0,0);
                    }
                    pdf.text(`${pedido.PEDIDO_NRO} `, x, y)
                    //pdf.text(`${pedido.NOMBRE_MESONERA.split(' ')[0]+' '+pedido.NOMBRE_MESONERA.split(' ')[2]}`, x + 12, y)
                    pdf.text(`${pedido.RETRASO_DS} min`, x + 12, y)
                    pdf.setTextColor(0, 0, 0);
                    pdf.setFillColor(0,0,0);
                    if (x === 10) { pdf.line(x, y + 2, x + 187, y + 2, 'F') }
                    y += 6
                    if (y >= 285) {
                        if(numCol<7){
                            pdf.line(x+30, nuevo?10:95, x+30, y-3, 'F')
                            pdf.setFont('Helvetica','bold');
                            pdf.text(`#Pe`,x+32,nuevo?10:93)
                            //pdf.text(`Despachadora`,x+75,nuevo?10:93);
                            pdf.text(`Tiempo`,x+44,nuevo?10:93);
                            pdf.setFont('Helvetica',null);
                        }
                        if (!nuevo) {
                            y = 100
                        } else {
                            y = 15
                        }
                        x += 32
                        numCol += 1
                        if (numCol >= 7) {
                            pdf.addPage()
                            infoPdf += 1;
                            numCol = 1;
                            nuevo = true;
                            y = 15
                            x = 10
                            pdf.setFont('Helvetica','bold');
                            pdf.text(`#Pe`,10,y-5);
                            //pdf.text(`Despachadora`,22,y-5);
                            pdf.text(`Tiempo`,22,y-5);
                            pdf.line(10, y-4, 197, y-4, 'F')
                            pdf.setFont('Helvetica',null);
                        }
                    }
                }
                pdf.save(`resumenMoto${fecha}.pdf`);
                setLoading(false)
            }).catch((error) => {
                console.log(error)
            })
        }).catch((error) => {
            console.log(error)
        })
    }
    return (
        <div className='bg-light text-center'>
            <div className='row row-cols-2 g-1'>
                <div className='col-2'>
                    <button className='btn btn-success' onClick={() => descargarResumen()}> descargar</button>
                </div>
                <div className='col-7'>
                    <div className="input-group mb-3">
                        <span className="input-group-text" id="basic-addon1">MOSTRAR PEDIDOS CON RETRASO MAYOR A </span>
                        <input type="number" className="form-control" value={filtro} onChange={(e)=>setFiltro(e.target.value)} />
                    </div>
                </div>
            </div>
            <div className='row row-cols-2 g-1 '>
                <div className='col graficasFacturacion'>
                    <GraficaMotosDos pedidos={pedidos} valMaximo={valMaximouno} tipo={'R'} innerRef={motoFactu} color='l' />
                </div>
                <div className='col graficasDespacho'>
                    <GraficaMotosDos pedidos={pedidos} valMaximo={valMaximodos} tipo={'M'} innerRef={motoDes} color='l' />
                </div>
            </div>
        </div>
    )
}

export default ResumenMotos